import { useQuery } from "@tanstack/react-query";
import client from "shared/utils/axios-config";
import { Package } from "shared/types";

/* eslint-disable react-hooks/rules-of-hooks */

// The catalogue pages and the buy modal read /v1/product
// (hooks/queries/product.ts); this file keeps only the upgrade picker.

// `enabled`: the server answers 404 for a package that cannot be upgraded
// (its filter requires is_valid), so callers that already know the answer must
// be able to skip the request. Upgraded-away packages became routinely
// reachable on 2026-09-21, and without this every visit to one logged a 404.
const getAllUpgradablePackageByCustomerPackageId = (
  customerPackageId?: string,
  enabled = true,
) => {
  return useQuery({
    queryKey: ["package", "upgrade", customerPackageId],
    queryFn: async (): Promise<Package[] | undefined> => {
      const res = await client.get(`/v1/package/upgrade/${customerPackageId}`);
      if (res.status === 200 && !res.data?.error) {
        return res.data.data;
      }
    },
    enabled: !!customerPackageId && enabled,
  });
};

export { getAllUpgradablePackageByCustomerPackageId };
